import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Welcome, Login, Signup, Dashboard, MorningCheckin, MorningPages, Settings, Profile, ProjectBoard, Projects, ProjectDetails, OpusDashboardPage, FlowTimer, BrainDump, EmergencyKit, Coach, Analytics, Partners, Challenges, Circles, Pulse } from './pages';
import { ThemeProvider, AuthProvider } from './context';
import { ToastProvider } from './components/ui';
import { ProtectedRoute } from './components/ProtectedRoute';
import './styles/global.css';

// Artist Workflow Platform Frontend
function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter>
          <AuthProvider>
            <div className="app">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Welcome />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />

                {/* Protected Routes */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/checkin"
                  element={
                    <ProtectedRoute>
                      <MorningCheckin />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/morning-pages"
                  element={
                    <ProtectedRoute>
                      <MorningPages />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute>
                      <Settings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/project/:id"
                  element={
                    <ProtectedRoute>
                      <ProjectBoard />
                    </ProtectedRoute>
                  }
                />

                {/* Placeholder routes - also protected */}
                <Route
                  path="/onboarding"
                  element={
                    <ProtectedRoute>
                      <Welcome />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/projects"
                  element={
                    <ProtectedRoute>
                      <Projects />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/projects/:id"
                  element={
                    <ProtectedRoute>
                      <ProjectDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/projects/:id/dashboard"
                  element={
                    <ProtectedRoute>
                      <OpusDashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/opus/:id"
                  element={
                    <ProtectedRoute>
                      <OpusDashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/timer"
                  element={
                    <ProtectedRoute>
                      <FlowTimer />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/ideas"
                  element={
                    <ProtectedRoute>
                      <BrainDump />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/more"
                  element={
                    <ProtectedRoute>
                      <EmergencyKit />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/coach"
                  element={
                    <ProtectedRoute>
                      <Coach />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/analytics"
                  element={
                    <ProtectedRoute>
                      <Analytics />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/partners"
                  element={
                    <ProtectedRoute>
                      <Partners />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/challenges"
                  element={
                    <ProtectedRoute>
                      <Challenges />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/circles"
                  element={
                    <ProtectedRoute>
                      <Circles />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/circles/:id"
                  element={
                    <ProtectedRoute>
                      <Circles />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/pulse"
                  element={
                    <ProtectedRoute>
                      <Pulse />
                    </ProtectedRoute>
                  }
                />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
